/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { getArea, saveArea } from "../../services/AreaService";
import { getCacheData } from "../../services/CacheService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  descripcion: "",
  descripcionCorta: "",
  internoExterno: "interno",
  actividad: "punto-de-venta",
  cedeArticulos: true,
  cedeArticulosOrden: 1,
  produccionTipoArea: "",
  produccionDeposito: false,
  produccionIngresaArticulos: false,
  email: "",
  domicilio: "",
  localidad: "",
  codigoPostal: "",
  idDepartamento: "",
  idProvincia: null,
  telefonoFijo: "",
  telefonoMovil: "",
  observaciones: "",
};

const actividadOptionsInterno = [
  {
    id: "punto-de-venta",
    descripcion: "Punto de Venta",
  },
  {
    id: "produccion",
    descripcion: "Produccion",
  },
];

const actividadOptionsExterno = [
  {
    id: "produccion",
    descripcion: "Produccion",
  },
];

const nameItemText = "Área";
const itemGender = "F";
//
// ###########################################################################
//
const AreaDialog = ({ onSave, onClose, itemCrud, actionCrud, setMessage, setShowMessage }) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [valueACDepartamentos, setValueACDepartamentos] = useState({
    id: "",
    label: "",
  });
  const [inputValueACDepartamentos, setInputValueACDepartamentos] =
    useState("");
  const [valueACProvincias, setValueACProvincias] = useState({
    id: "",
    label: "",
  });
  const [inputValueACProvincias, setInputValueACProvincias] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [actividadOptions, setActividadOptions] = useState(actividadOptionsInterno);
  const [disabledCedeArticulosOrden, setDisabledCedeArticulosOrden] = useState(true);
  //
  // ################################################################################
  //
  useEffect(() => {
    loadDeparmentos();
    loadProvincias();

    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      const loadItem = async () => {

        setIsDoingSomething(true);
        const response = await getArea({ id: itemCrud });
        setIsDoingSomething(false);

        if (response.ok) {
          let _response = response.data.data[0];

          let _itemCrud = {
            id: _response.id,
            descripcion: _response.descripcion,
            descripcionCorta: _response.descripcion_corta,
            internoExterno: _response.interno_externo,
            actividad: _response.actividad,
            cedeArticulos: _response.cede_articulos,
            cedeArticulosOrden: _response.cede_articulos_orden,
            produccionTipoArea: _response.produccion_inicial
              ? "inicial"
              : _response.produccion_final
                ? "final"
                : _response.produccion_despacho
                  ? "despacho"
                  : "",
            produccionDeposito: _response.produccion_deposito,
            produccionIngresaArticulos: _response.produccion_ingresa_articulos,
            email: _response.email,
            domicilio: _response.domicilio,
            localidad: _response.localidad,
            codigoPostal: _response.codigo_postal,
            departamento: {
              id: _response.id_departamento,
              label: _response.descripcion_departamento,
            },
            provincia: {
              id: _response.id_provincia,
              label: _response.descripcion_provincia,
            },
            telefonoFijo: _response.telefono_fijo,
            telefonoMovil: _response.telefono_movil,
            observaciones: _response.observaciones,
          };

          setItemCrudLocal(_itemCrud);
          setValueACDepartamentos(_itemCrud.departamento);
          setValueACProvincias(_itemCrud.provincia);
        } else {
          setMessage({
            severity: response.messageSeverity,
            messageText: response.messageText,
          });
          setShowMessage(true);
          return;
        }
      };
      loadItem();
    }
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (itemCrudLocal.internoExterno === "interno") {
      setActividadOptions(actividadOptionsInterno);
      setItemCrudLocal({
        ...itemCrudLocal,
        actividad: "punto-de-venta",
      });
    } else {
      setActividadOptions(actividadOptionsExterno);
      setItemCrudLocal({
        ...itemCrudLocal,
        actividad: "produccion",
      });
    }
  }, [itemCrudLocal.internoExterno]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (itemCrudLocal.internoExterno === "interno") {
      // si es un area interna

      if (itemCrudLocal.actividad === "punto-de-venta") {
        // si es un punto de venta
        setItemCrudLocal({
          ...itemCrudLocal,
          cedeArticulos: false,
          cedeArticulosOrden: 0,
        });
      } else {
        // si es produccion
        setItemCrudLocal({
          ...itemCrudLocal,
          produccionDeposito: false,
          produccionIngresaArticulos: false,
          produccionTipoArea: "",
        });
      }
    } else {
      // si es un area externa
      setItemCrudLocal({
        ...itemCrudLocal,
        produccionDeposito: false,
        actividad: "produccion",
      });
    }
  }, [itemCrudLocal.actividad]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (itemCrudLocal.cedeArticulos) {
      setDisabledCedeArticulosOrden(false);
      setItemCrudLocal({
        ...itemCrudLocal,
        cedeArticulosOrden: 1,
      });
    } else {
      setDisabledCedeArticulosOrden(true);
      setItemCrudLocal({
        ...itemCrudLocal,
        cedeArticulosOrden: 0,
      });
    }
  }, [itemCrudLocal.cedeArticulos]);
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]: e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleChangeInternoExterno = (event, newValue) => {
    if (newValue !== null) {
      setItemCrudLocal({
        ...itemCrudLocal,
        internoExterno: newValue,
      });
    }
  };
  //
  // ################################################################################
  //
  const handleChangeProduccionTipoArea = (event, newValue) => {
    if (newValue !== null) {
      setItemCrudLocal({
        ...itemCrudLocal,
        produccionTipoArea: newValue,
      });
    } else {
      setItemCrudLocal({
        ...itemCrudLocal,
        produccionTipoArea: "",
      });
    }
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {
      if (itemCrudLocal.descripcion === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar el nombre del Area",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.descripcionCorta === "") {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Descripción corta del Area",
        });
        setShowMessage(true);
        return;
      }

      if (itemCrudLocal.internoExterno === "interno") {
        if (itemCrudLocal.actividad === "punto-de-venta") {
          if (itemCrudLocal.cedeArticulos) {
            if (+itemCrudLocal.cedeArticulosOrden === 0) {
              setMessage({
                severity: "error",
                messageText: "Debes ingresar el Orden en el que cede Armazones y Anteojos de Sol",
              });
              setShowMessage(true);
              return;
            }
          }
        }
      }
    }
    save();
  };
  //
  // ##########################################################################
  //
  const save = async () => {
    let _itemCrud = {
      descripcion: itemCrudLocal.descripcion,
      descripcion_corta: itemCrudLocal.descripcionCorta,
      interno_externo: itemCrudLocal.internoExterno,
      actividad: itemCrudLocal.actividad,
      cede_articulos: itemCrudLocal.cedeArticulos,
      cede_articulos_orden: +itemCrudLocal.cedeArticulosOrden,
      produccion_deposito: itemCrudLocal.produccionDeposito,
      produccion_ingresa_articulos: itemCrudLocal.produccionIngresaArticulos,
      produccion_inicial: itemCrudLocal.produccionTipoArea === "inicial" ? true : false,
      produccion_final: itemCrudLocal.produccionTipoArea === "final" ? true : false,
      produccion_despacho: itemCrudLocal.produccionTipoArea === "despacho" ? true : false,
      email: itemCrudLocal.email,
      telefono_fijo: itemCrudLocal.telefonoFijo,
      telefono_movil: itemCrudLocal.telefonoMovil,
      domicilio: itemCrudLocal.domicilio,
      localidad: itemCrudLocal.localidad,
      codigo_postal: itemCrudLocal.codigoPostal,
      id_departamento: valueACDepartamentos.id || "",
      id_provincia: valueACProvincias.id || "",
      observaciones: itemCrudLocal.observaciones,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrudLocal.id;
    }

    setIsDoingSomething(true);
    const response = await saveArea(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };
  //
  // ################################################################################
  //
  const loadDeparmentos = async () => {
    const response = await getCacheData("departamento");
    if (response.ok) {
      let _response = response.data.data;
      let _departamentos = [];
      _response.forEach((item) => {
        _departamentos.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setDepartamentos(_departamentos);
    } else {
      setDepartamentos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadProvincias = async () => {
    const response = await getCacheData("provincia");
    if (response.ok) {
      let _response = response.data.data;
      let _provincias = [];
      _response.forEach((item) => {
        _provincias.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setProvincias(_provincias);
    } else {
      setProvincias([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>

            <Grid item xs={12}>
              <TextField
                id="descripcion"
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 50,
                }}
                variant="outlined"
                size="small"
                name="descripcion"
                label="Area"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                  maxLength: 20,
                }}
                id="descripcionCorta"
                label="Descripción corta"
                variant="outlined"
                size="small"
                name="descripcionCorta"
                value={itemCrudLocal.descripcionCorta}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              {/* area interna o externa */}
              <ToggleButtonGroup
                color="primary"
                value={itemCrudLocal.internoExterno}
                exclusive={true}
                fullWidth={true}
                orientation="horizontal"
                size="small"
                onChange={handleChangeInternoExterno}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              >
                <ToggleButton value="interno" size="small">
                  Area Interna
                </ToggleButton>
                <ToggleButton value="externo" size="small">
                  Area Externa
                </ToggleButton>
              </ToggleButtonGroup>
            </Grid>

            <Grid item xs={12}>
              <FormControl sx={{ width: "100%" }}>
                <InputLabel id="actividad-select-label">Actividad</InputLabel>
                <Select
                  sx={{ width: "100%" }}
                  labelId="actividad"
                  label="Actividad"
                  id="actividad"
                  name="actividad"
                  value={itemCrudLocal.actividad}
                  size="small"
                  onChange={handleChange}
                  disabled={actionCrud === "disable" || actionCrud === "enable"}
                >
                  {actividadOptions.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {itemCrudLocal.internoExterno === "interno" &&
              itemCrudLocal.actividad === "punto-de-venta" && (
                <>
                  <Grid item xs={6}>
                    <FormControlLabel
                      sx={{ width: "100%" }}
                      control={
                        <Checkbox
                          id="cede-articulos"
                          name="cedeArticulos"
                          checked={itemCrudLocal.cedeArticulos}
                          onChange={handleChange}
                          disabled={actionCrud === "disable" || actionCrud === "enable"}
                        />
                      }
                      label="Cede Armazones y Anteojos de Sol"
                    />
                  </Grid>

                  <Grid item xs={6}>
                    <TextField
                      sx={{ width: "20%" }}
                      inputProps={{
                        style: { textAlign: "center" },
                        type: "number",
                        min: 1,
                        step: 1,
                      }}
                      id="cedeArticulosOrden"
                      label="Orden"
                      variant="outlined"
                      size="small"
                      name="cedeArticulosOrden"
                      value={itemCrudLocal.cedeArticulosOrden}
                      onChange={handleChange}
                      disabled={
                        actionCrud === "disable" ||
                        actionCrud === "enable" ||
                        disabledCedeArticulosOrden
                      }
                    />
                  </Grid>
                </>
              )}

            {itemCrudLocal.internoExterno === "interno" &&
              itemCrudLocal.actividad === "produccion" && (
                <>
                  <Grid item xs={6}>
                    <FormControlLabel
                      sx={{ mx: "auto" }}
                      control={
                        <Checkbox
                          id="produccion-deposito"
                          name="produccionDeposito"
                          checked={itemCrudLocal.produccionDeposito}
                          onChange={handleChange}
                          disabled={actionCrud === "disable" || actionCrud === "enable"}
                        />
                      }
                      label="Es el área de Depósito"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControlLabel
                      sx={{ mx: "auto" }}
                      control={
                        <Checkbox
                          id="produccion-ingresa-articulos"
                          name="produccionIngresaArticulos"
                          checked={itemCrudLocal.produccionIngresaArticulos}
                          onChange={handleChange}
                          disabled={actionCrud === "disable" || actionCrud === "enable"}
                        />
                      }
                      label="Puede registrar Ingreso de Artículos"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={4} lg={12}>
                    <Box sx={{ mb: 1 }}>
                      {/* area de produccion inicial / final / despacho */}
                      <ToggleButtonGroup
                        color="primary"
                        value={itemCrudLocal.produccionTipoArea}
                        exclusive={true}
                        fullWidth={true}
                        orientation="horizontal"
                        size="small"
                        onChange={handleChangeProduccionTipoArea}
                        disabled={actionCrud === "disable" || actionCrud === "enable"}
                      >
                        <ToggleButton value="inicial" size="small">
                          Area Inicial de Producción
                        </ToggleButton>
                        <ToggleButton value="final" size="small">
                          Area Final de Producción
                        </ToggleButton>
                        <ToggleButton value="despacho" size="small">
                          Area de Despacho
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Box>
                  </Grid>
                </>
              )}

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="email"
                label="E-mail"
                variant="outlined"
                size="small"
                name="email"
                value={itemCrudLocal.email}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="domicilio"
                label="Domicilio"
                variant="outlined"
                size="small"
                name="domicilio"
                value={itemCrudLocal.domicilio}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={8}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="localidad"
                label="Localidad"
                variant="outlined"
                size="small"
                name="localidad"
                value={itemCrudLocal.localidad}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="codigoPostal"
                label="Código Postal"
                variant="outlined"
                size="small"
                name="codigoPostal"
                value={itemCrudLocal.codigoPostal}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                size="small"
                value={valueACDepartamentos}
                onChange={(event, newValue) => {
                  setValueACDepartamentos(newValue);
                }}
                inputValue={inputValueACDepartamentos}
                onInputChange={(event, newInputValue) => {
                  setInputValueACDepartamentos(newInputValue);
                }}
                id="Departamento"
                options={departamentos}
                renderInput={(params) => <TextField {...params} label="Departamento" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                getOptionLabel={(option) => option.label || ""}
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                size="small"
                value={valueACProvincias}
                onChange={(event, newValue) => {
                  setValueACProvincias(newValue);
                }}
                inputValue={inputValueACProvincias}
                onInputChange={(event, newInputValue) => {
                  setInputValueACProvincias(newInputValue);
                }}
                id="Provincia"
                options={provincias}
                renderInput={(params) => <TextField {...params} label="Provincia" />}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
                getOptionLabel={(option) => option.label || ""}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="telefonoFijo"
                label="Teléfono fijo"
                variant="outlined"
                size="small"
                name="telefonoFijo"
                value={itemCrudLocal.telefonoFijo}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="telefonoMovil"
                label="Teléfono movil"
                variant="outlined"
                size="small"
                name="telefonoMovil"
                value={itemCrudLocal.telefonoMovil}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off",
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: "80px",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  size="small"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default AreaDialog;
